import { render, staticRenderFns } from "./VideoEdit.vue?vue&type=template&id=017a5a5c&scoped=true&"
import script from "./VideoEdit.vue?vue&type=script&lang=js&"
export * from "./VideoEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017a5a5c",
  null
  
)

export default component.exports